const modalStyleOverrides = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
  },
  content: {
    position: 'fixed',
    top: 'unset',
    left: '50%',
    right: 'unset',
    bottom: '0px',
    padding: '0px',
    paddingBottom: 10,
    width: 'fit-content',
    background: 'var(--main-bg-surface-alt)',
    boxShadow: '0 3px 20px 0 rgba(0, 0, 0, 0.16)',
    border: 'none',
    overflow: 'auto',
    borderRadius: 0,
  },
};

export default modalStyleOverrides;
